var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRtColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1417 4L6 5.175L9.7085 9L6 12.825L7.1417 14L12 9L7.1417 4Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRtColor);
export default __webpack_public_path__ + "static/media/icon_arrow_rt_color.a6b9016829cd263c9edbdd439456e34a.svg";
export { ForwardRef as ReactComponent };